import React from 'react';
import { TextField } from '@mui/material';

const SimpleTextField = ({ label, value, onChange, required, helperText, error}) => {
  return (
    <TextField
      fullWidth
      label={label}
      variant="outlined"
      value={value || ""}
      required={required}
      helperText={helperText}
      onChange={(e) => onChange(e.target.value)} // Directly passing the new value to onChange
      // error={error ? !!error : false} // true  (if "Some error" is a non-empty string)
    />
  );
};

export default SimpleTextField;
